import {
  PriceRoundingRuleConfig,
  RoundingModeDTO,
  RoundingRuleRangeDTO,
} from '@retail/rounding/types';
import { PriceRoundingRuleConfigSchema } from '@retail/rounding/components';

export const mapConfigToSchema = (
  config: PriceRoundingRuleConfig
): Partial<PriceRoundingRuleConfigSchema> => ({
  name: config.name,
  rules: config.ranges.map((range) => ({
    priceFrom: range.priceFrom,
    priceTo: range.priceTo,
    roundingMode: range.roundingMode,
    targetEndings: range.targetEndings,
  })),
});

export const mapRulesSchemaToDto = (
  rules: PriceRoundingRuleConfigSchema['rules']
): RoundingRuleRangeDTO[] =>
  rules.map(
    ({ priceFrom, priceTo, roundingMode, targetEndings }) =>
      ({
        priceFrom,
        priceTo,
        roundingOption: roundingMode as RoundingModeDTO,
        targetEndings,
      } satisfies RoundingRuleRangeDTO)
  );
